const title = 'Apply'
export default [
  {
    path: 'apply-document-all',
    name: 'apply-document-all',
    component: () => import('@/views/pages/apply-document/ApplyDocumentInno.vue'),
    meta: {
      pageTitle: `${title} Documents All`,
      breadcrumb: [
        {
          text: `${title} Documents All`,
          active: true,
        },
      ],
      resource: 'ApplyDocumentAll',
      isInno: true,
      isOtm: false,
    },
  },
  {
    path: 'apply-document-all/:id',
    name: 'apply-document-all-view',
    component: () => import('@/views/pages/apply-document/View.vue'),
    meta: {
      pageTitle: title,
      breadcrumb: [
        {
          to: { name: 'apply-document-all' },
          text: `${title} Documents All`,
          active: false,
        },
        {
          text: `${title} Document`,
          active: true,
        },
      ],
      isInno: true,
      isOtm: false,
      resource: 'ApplyDocumentAll',
    },
  },
]
